export default __webpack_public_path__ + "static/media/line-h-06.b3969b54.png";